import * as turfHelpers from "@turf/helpers";
import turfArea from "@turf/area";
import turfLength from "@turf/length";

export const getArea = ({ type, coordinates }) => {
  try {
    const isMultiPolygon = type.toLowerCase() === "multipolygon";
    const polygon = isMultiPolygon ? turfHelpers.multiPolygon(coordinates) : turfHelpers.polygon(coordinates);
    const area = turfArea(polygon);
    return area;
  } catch (e) {
    console.error("Error calculating area:", e.message);
  }
  return null;
};

export const getPerimeter = ({ type, coordinates }) => {
  try {
    const isMultiPolygon = type.toLowerCase() === "multipolygon";
    const line = turfHelpers.lineString(isMultiPolygon ? coordinates[0][0] : coordinates[0]);
    const length = turfLength(line, { units: "meters" });
    return length;
  } catch (e) {
    console.error("Error calculating perimeter:", e.message);
  }
  return null;
};
